import { render, staticRenderFns } from "./outBox.vue?vue&type=template&id=9967a224&scoped=true&"
import script from "./outBox.vue?vue&type=script&lang=js&"
export * from "./outBox.vue?vue&type=script&lang=js&"
import style0 from "./outBox.vue?vue&type=style&index=0&id=9967a224&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9967a224",
  null
  
)

export default component.exports